




















import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import { Dashboard } from '@/api/model/dashboard'
import { DashboardAPI } from '@/api/backend-client'
import Tabs from '@/views/Reports/Report/Tabs.vue'
import CumulioReport from '@/views/Reports/Report/CumulioReport.vue'
import PowerBiReport from '@/views/Reports/Report/PowerBiReport.vue'
import SalesReport from '@/views/Reports/Report/SalesReport.vue'

@Component({
    components: {
        Tabs,
        CumulioReport,
        PowerBiReport,
        SalesReport,
    },
})
export default class Report extends Vue {
    @Prop({ required: true }) readonly dashboardId: string
    dashboard: Dashboard = null
    loading: boolean = false

    async mounted(): Promise<void> {
        await this.loadDashboard()
    }

    @Watch('dashboardId')
    async loadDashboard(): Promise<void> {
        this.loading = true
        this.dashboard = await DashboardAPI.get(this.dashboardId)
        this.loading = false
    }
}
